import React, { memo } from 'react';
import {
  ToolbarCheckCircleIcons,
  ToolbarClearIcons,
  ToolbarMailIcons,
} from '../../../../../../icons/icons';
import { ActionButton } from './ActionButton';
import { UnsuccessfulApplicantsActionsProps } from './interfaces';

export const UnsuccessfulApplicantsActions =
  memo<UnsuccessfulApplicantsActionsProps>(
    ({
      selectAllUnsuccessful,
      handleClearSelected,
      isClearDisabled,
      handleSendEmailToSelected,
      isSendEmailDisabled,
      selectedApplicantCount,
    }) => (
      <div className='flex items-center gap-1 ml-0.5 pl-0.5'>
        <ActionButton
            onClick={selectAllUnsuccessful}
            variant='blue'
            icon={
              <ToolbarCheckCircleIcons className='w-3.5 h-3.5 group-hover:-translate-y-0.5 transition-transform duration-200' />
            }
            label='Select All'
            title='Select all candidates in Unsuccessful-Pending status (emails not yet sent)'
            hideOnSmall
        />

        <ActionButton
            onClick={handleClearSelected}
            disabled={isClearDisabled}
            variant='red'
            icon={
              <ToolbarClearIcons
                  className={`w-3.5 h-3.5 ${
                    isClearDisabled ? '' : 'group-hover:-translate-y-0.5'
                  } transition-transform duration-200`}
              />
            }
            label='Clear'
            title='Clear selection'
            hideOnSmall
        />

        <button
            onClick={handleSendEmailToSelected}
            disabled={isSendEmailDisabled}
            className={`group h-7 sm:h-8.5 px-3 sm:px-4 rounded-lg transition-all duration-300 flex items-center gap-1 sm:gap-2 font-medium text-xs sm:text-sm whitespace-nowrap ${
              isSendEmailDisabled
                ? 'bg-transparent text-slate-300 cursor-not-allowed opacity-40'
                : 'bg-red-50 text-red-600 hover:bg-red-100/80 active:bg-red-200/50 shadow-sm shadow-red-500/10'
            }`}
            title={`Send emails to ${selectedApplicantCount} selected candidates`}
            aria-label={`Send emails to ${selectedApplicantCount} selected candidates`}
        >
          <ToolbarMailIcons
              className={`w-3.5 h-3.5 ${
                selectedApplicantCount === 0 ? '' : 'group-hover:rotate-6'
              } transition-transform duration-200`}
          />
          <span className='truncate'>Email ({ selectedApplicantCount })</span>
        </button>
      </div>
    ),
  );

UnsuccessfulApplicantsActions.displayName = 'UnsuccessfulApplicantsActions';
